// Mock content data for Whitemoon Magnesium (frontend-only teaser).
// All content sourced from public company material; swap with real CMS/backend later.
import ecShaftAerial from './assets/gallery/g0.jpg';
import ecHeadframe from './assets/gallery/g1.jpg';
import ecMonument from './assets/gallery/g2.jpg';
import ecTimbers from './assets/gallery/g3.jpg';
import ecAerialPan from './assets/gallery/g4.jpg';
import ecClaims from './assets/gallery/g5.jpg';
import heroClaims from './assets/hero-claims.jpg';
import heroTimbers from './assets/hero-timbers.jpg';
import ecMagnesite from './assets/gallery/g6.jpg';
import ecMonument2 from './assets/gallery/g7.jpg';
import wmFolding from './assets/gallery/wm0.jpg';
import wmAerialMineral from './assets/gallery/wm1.jpg';
import wmAerialHills from './assets/gallery/wm2.jpg';
import wmRidge from './assets/gallery/wm3.jpg';
import wmWall from './assets/gallery/wm4.jpg';
import siteLandscape from './assets/site-landscape.jpg';
import projectMagnesite from './assets/project-magnesite.jpg';
import projectWhitemoon from './assets/project-whitemoon.jpg';
import projectElCapitan from './assets/project-elcapitan.jpg';

export const company = {
  name: 'Whitemoon',
  fullName: 'Whitemoon Magnesium',
  tagline: 'An American Magnesium Solution',
  element: { number: '12', symbol: 'Mg', mass: '24.305' },
  location: 'San Bernardino County, California',
  email: 'info@whitemoonmg.com',
  linkedin: 'https://www.linkedin.com/company/whitemoonmg/',
  phone: '+1 (760) 555-0199',
  copyright: `Copyright \u00A9 ${new Date().getFullYear()} Whitemoon Magnesium - All Rights Reserved.`,
};

export const nav = [
  { label: 'Home', path: '/' },
  { label: 'Magnesium', path: '/magnesium' },
  { label: 'Project', path: '/project' },
  { label: 'History', path: '/history' },
  { label: 'Gallery', path: '/gallery' },
  { label: 'Investors', path: '/investors' },
  { label: 'Contact', path: '/contact' },
];

export const images = {
  heroDesert: siteLandscape,
  aerialPit: ecShaftAerial,
  desertMountain: siteLandscape,
  openPit: heroTimbers,
  quarry: heroClaims,
  mineral: projectMagnesite,
  // El Capitan / Whitemoon site photography
  ecShaftAerial,
  ecHeadframe,
  ecMonument,
  ecTimbers,
  ecAerialPan,
  ecClaims,
  ecMagnesite,
  ecMonument2,
  wmFolding,
  wmAerialMineral,
  wmAerialHills,
  wmRidge,
  wmWall,
  siteLandscape,
  projectWhitemoon,
  projectElCapitan,
  // Industrial application imagery (stock)
  aircraft: 'https://images.unsplash.com/photo-1674897537555-dd6fbf72b4eb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwyfHxhaXJjcmFmdCUyMG1hbnVmYWN0dXJpbmd8ZW58MHx8fHwxNzg1ODY5MDQxfDA&ixlib=rb-4.1.0&q=85',
  jetEngine: 'https://images.unsplash.com/photo-1464490997959-0c65eee1cc26?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHw0fHxhaXJjcmFmdCUyMG1hbnVmYWN0dXJpbmd8ZW58MHx8fHwxNzg1ODY5MDQxfDA&ixlib=rb-4.1.0&q=85',
  auto: 'https://images.pexels.com/photos/19233057/pexels-photo-19233057.jpeg',
  industrialMetal: 'https://images.unsplash.com/photo-1763926062529-1edf8664c366?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHw0fHxpbmR1c3RyaWFsJTIwbWV0YWx8ZW58MHx8fHwxNzg1ODY5MDQ3fDA&ixlib=rb-4.1.0&q=85',
  alloyBars: 'https://images.unsplash.com/photo-1681108212545-04cabe9cf771?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwyfHxtZXRhbCUyMGFsbG95fGVufDB8fHx8MTc4NTg2OTA0MXww&ixlib=rb-4.1.0&q=85',
};

export const homeIntro =
  'Whitemoon Magnesium is a US-based exploration and development company focused on 100%-owned historical claims in San Bernardino County, California - including the historic Whitemoon Magnesite Deposit and the El Capitan Deposit.';

export const homeParagraphs = [
  'The Whitemoon Magnesite Deposit sits on 55 acres of private patented land, surrounded by 200 acres of placer / lode claims near the Arizona and Nevada borders.',
  'Whitemoon is a historic mining site with visible magnesite material at surface, open at depth, and clear evidence of past operations - a high-grade, high-purity magnesite deposit on US soil.',
  'San Bernardino County is a mining-friendly region with 90+ active mines, including Equinox Gold\u2019s Castle Mountain Mine (60km) and MP Materials\u2019 Mountain Pass Rare Earth Mine (100km).',
  'Magnesium is a listed critical mineral in both the US and EU - vital to aerospace, automotive and defense. China dominates ~90% of global supply while US production is effectively zero. Whitemoon aims to help restore domestic supply security.',
];

export const homeStats = [
  { value: '46.3%', label: 'Peak MgO grade' },
  { value: '~2M', label: 'Tonnes of potential magnesite' },
  { value: '~90%', label: 'Global supply controlled by China' },
  { value: '100%', label: 'Company-owned claims' },
];

export const projectFacts = [
  'The Whitemoon and El Capitan deposits are bedded sedimentary magnesite deposits ~5 miles apart on the western flank of the Sacramento Mountains. Whitemoon is the better exposed: a shallow lens ~600 ft wide and ~2,400 ft long outcropping at surface. El Capitan is two parallel beds, dipping steeply west, with mapped magnesite occurrences along ~1.5 miles of strike.',
  'The Vitaliano Report (1950, California Journal of Mines and Geology) recorded MgO grades as high as 46.3% against a theoretical maximum of 47.8%, with very low iron (0.05% Fe\u2082O\u2083), and estimated 527,000 tonnes at the surface of Whitemoon.',
  'Steve Kupferman\u2019s (Principal Geologist) 2017 report referenced The California Geological Survey (1985) which classified Whitemoon as unusually pure, with approximately 1 million tons of magnesite exposed at surface and additional resources expected at depth.',
  'The Kraemer Report (2020, JORC 2012 Competent Person) expanded the interpreted host area to ~480,000 m\u00B2, supporting an Exploration Target on the order of 4 million tons, and separately records anecdotal historical accounts suggesting mineralization may extend to 5\u201310 million tons at depth - historical context only, to be tested by drilling.',
  'Seventy-five years. Four independent reviews. The estimate has only moved up - and no drill hole has ever tested either deposit. Confirming tonnage is the primary objective of Whitemoon\u2019s phase 1 drill program.',
];

export const projectFactsFootnote =
  'Historical estimates are not current Mineral Resources. The Exploration Target is conceptual in nature; there has been insufficient exploration to define a Mineral Resource and it is uncertain whether further exploration will result in one.';

export const projectSpecs = [
  { k: 'Lens width', v: '~600 ft' },
  { k: 'Lens length', v: '~2,400 ft' },
  { k: 'Surface exposure', v: '~1M mt' },
];

export const elCapitanSpecs = [
  { k: 'Strike width', v: '~800 ft' },
  { k: 'Strike length', v: '~1.5 mi' },
  { k: 'Grade', v: 'up to 46.3% MgO' },
];

export const miningTitle = 'Simple mining, close to infrastructure.';
export const miningIntro =
  'Magnesite crops out at surface across both deposits, so Whitemoon is designed as a straightforward open-pit operation - no shafts, no dewatering, no underground development.';
export const mining = [
  {
    title: 'Open-pit mining',
    desc: 'Mineralization starts at grade level under minimal overburden. Drill, blast, load and haul in benches - the simplest, lowest-capital form of hard-rock mining.',
  },
  {
    title: 'Crush and screen',
    desc: 'Ore is crushed and sized on site, with established third-party crushing and processing capacity available in the region while the company builds its own plant.',
  },
  {
    title: 'Rail and highway access',
    desc: 'The claims sit near interstate highway and Class I rail corridors, giving direct freight access to domestic refractory, construction and metal customers.',
  },
  {
    title: 'Established mining district',
    desc: 'San Bernardino County hosts 90+ active mines, with regional power, water, contractors and an experienced mining workforce already in place.',
  },
];

export const magnesiumFacts = [
  'Magnesium is the lightest structural metal - 33% lighter than aluminum and 75% lighter than steel - with a favorable strength-to-weight ratio.',
  'Its alloys offer high heat transfer, vibration damping and electromagnetic-interference reduction, making them ideal for high-performance, precision applications.',
  'Primarily used across automotive and aerospace for frames, engine components and more.',
  'Used in Thixomolding and Giga-casting to efficiently produce large, lightweight alloy components in a single process.',
  'Also used in chemical applications - marine flares, and as salts in foods and fertilizers.',
  'Fully recyclable: secondary production uses only ~5% of the energy of primary magnesium alloy, offering a strong sustainability profile.',
];

export const geopolitics = [
  'Magnesium is critical for industrial and military applications and appears on the critical-minerals lists of both the US Geological Survey and the European Commission.',
  'Production is among the most geographically concentrated of any commodity. China alone accounts for nearly 90% of world magnesium metal production.',
  'In 2021, the last US producer idled operations at the Great Salt Lake project, one of the most polluted industrial sites in North America.',
  'Per the USGS, the US imports over 75% of its magnesium, and demand is rising across aerospace, automotive and defense.',
];

export const mgo = {
  eyebrow: 'Magnesium Oxide (MgO)',
  title: 'The industrial workhorse of magnesium, and Whitemoon\u2019s first product.',
  propertiesTitle: 'One ore. One kiln. Many markets.',
  properties: [
    'Magnesium oxide - magnesia - is produced by calcining magnesite, the mineral Whitemoon owns. Heating drives off CO\u2082 and leaves a white, high-purity oxide.',
    'MgO melts at 2,852\u00B0C, among the highest of any common material and the reason the world\u2019s steel, cement and glass furnaces are lined with it.',
    'One ore body serves multiple markets by calcination temperature alone: caustic-calcined magnesia for agriculture, environment and chemicals; dead-burned magnesia for refractories; fused magnesia for premium electrical and refractory applications.',
    'Formed into MgO board, the same oxide becomes a non-combustible alternative to gypsum drywall: it does not burn, resists water and mold, and can lift the fire rating of a wall or roof assembly - increasingly specified as building codes tighten in wildfire and high-density zones.',
  ],
  stats: [
    { value: '2,852\u00B0C', label: 'Melting point, among the highest of any material' },
    { value: '~2 tonnes', label: 'Magnesite ore to produce 1 tonne of MgO' },
    { value: '1', label: 'U.S. producer of magnesia from domestically mined ore today' },
  ],
  applicationsTitle: 'Where MgO matters.',
  applications: [
    { title: 'Refractories', desc: 'Furnace linings for steel, cement and glass: magnesia\u2019s largest global market.' },
    { title: 'Construction', desc: 'Fire-resistant MgO board and panels for modern building systems.' },
    { title: 'Agriculture & Environment', desc: 'Animal feed, fertilizer, water treatment and flue-gas scrubbing.' },
    { title: 'Metal Feedstock', desc: 'The direct input for thermal-reduction magnesium metal: the bridge from MgO to Mg.' },
  ],
  supplyTitle: 'The same fragile chain, one step upstream.',
  supply: [
    'China dominates global magnesia supply, and environmental curtailments have repeatedly tightened exports and lifted prices.',
    'The United States has a single producer of magnesia from domestically mined ore, and imports the balance of its needs.',
  ],
  supplyCallout:
    'Every tonne of domestic MgO capacity shortens the same supply chain that magnesium metal depends on - which is why Whitemoon\u2019s strategy begins with MgO: revenue first, metal as the next step.',
};

export const downstream = {
  eyebrow: 'Domestic Downstream Processing',
  title: 'Whitemoon ore to 99.9% pure magnesium metal, on US soil.',
  lead:
    'Whitemoon Magnesium has successfully completed lab testing with US-based Big Blue Technologies, using their proprietary Aluminothermal Reduction (ATR) process to convert Whitemoon ore into 99.9% pure magnesium metal.',
  body:
    'The ATR process reacts a magnesium-bearing ore (MgO or MgO-CaO) with aluminum to produce metal plus a value-add byproduct. With MgO, magnesium aluminate spinel is co-produced, a material critical to high-performance refractories. With MgO-CaO, the byproduct is calcium aluminate, used in cement and advanced building materials.',
  advantagesTitle: 'Advantages of ATR',
  advantages: [
    'Low energy use',
    'High material efficiency',
    'Automation to enhance safety',
    'Value-add byproducts',
  ],
  flowTitle: 'Aluminothermal Reduction (ATR)',
  flow: [
    { label: 'MgO', op: '+' },
    { label: 'CaO', op: '+' },
    { label: 'Al', op: '=' },
    { label: 'Mg', op: '+' },
    { label: 'CaAl', op: '' },
  ],
  photoCaption: 'Magnesium metal produced from Whitemoon ore at Big Blue Technologies, lab scale.',
  partnerNote: 'Lab testing partner - Big Blue Technologies, Colorado',
};

export const applications = [
  { title: 'Aerospace', desc: 'Airframes, housings and engine components where every gram matters.', img: 'aircraft' },
  { title: 'Automotive & EV', desc: 'Giga-cast structures and lightweight frames for the electric era.', img: 'auto' },
  { title: 'Alloys & Casting', desc: 'Thixomolded and die-cast precision parts at production scale.', img: 'alloyBars' },
  { title: 'Defense & Tech', desc: 'Dual-use critical mineral for strategic industrial supply.', img: 'industrialMetal' },
];

export const timeline = [
  { year: '1935', text: 'California Chemical Co. completed the first geologic survey of magnesite in the Whitemoon area - 60 trenches and four diamond drill holes with positive results.' },
  { year: '1941', text: 'Basic Magnesium, Inc. examined and mapped the property.' },
  { year: '1942', text: 'The Defense Plant Corporation mapped the deposit and analyzed 27 samples; the USGS conducted studies on the site.' },
  { year: '1943', text: 'Charles Vitaliano of the USGS mapped Whitemoon and Capitan. A private lessee opened a small quarry with two shafts before operations ceased.' },
  { year: '1950', text: 'Vitaliano published the Vitaliano Report in the California Journal of Mines and Geology - magnesium grades up to 46.3%.' },
  { year: '1985', text: 'The California Geological Survey classified the area as holding significant measured / indicated resources with high purity.' },
  { year: '2020', text: 'Kraemer Consulting Natural Resources estimated deposit size using satellite imagery and Vitaliano figures.' },
  { year: '2022', text: 'SWCA Environmental Consultants conducted site visits and permitting reports; Dr. Lawrence Snee supported an exploration program with samples assayed at ALS labs.' },
  { year: '2026', text: 'Certificate of Land Use Compliance approval recognizing Whitemoon\u2019s right to mine.' },
];

export const galleryItems = [
  { img: 'ecShaftAerial', title: 'Whitemoon Shaft Collar - Aerial', tag: 'Site' },
  { img: 'ecHeadframe', title: 'El Capitan Headframe', tag: 'Site' },
  { img: 'ecMonument', title: 'GLO Survey Monument', tag: 'Survey' },
  { img: 'ecTimbers', title: 'Historic Shaft Timbers', tag: 'Operations' },
  { img: 'ecClaims', title: 'Claim Boundaries - Aerial', tag: 'Landscape' },
  { img: 'wmFolding', title: 'Whitemoon Magnesite', tag: 'Whitemoon' },
  { img: 'wmAerialMineral', title: 'Whitemoon - Aerial', tag: 'Whitemoon' },
  { img: 'wmAerialHills', title: 'Whitemoon - Aerial', tag: 'Whitemoon' },
  { img: 'wmRidge', title: 'Whitemoon Ridge', tag: 'Whitemoon' },
  { img: 'wmWall', title: 'Whitemoon Rock Face', tag: 'Whitemoon' },
  { img: 'ecMagnesite', title: 'High-Purity Magnesite', tag: 'Ore' },
  { img: 'ecMonument2', title: 'GLO Survey Monument (1943)', tag: 'Survey' },
];

export const usgsMap = {
  eyebrow: 'National Context',
  title: 'Whitemoon is on the map.',
  body:
    'The USGS maps mines and mineral deposits with identified critical mineral resources across the United States. Magnesium is on that critical minerals list, and primary production no longer exists domestically. Whitemoon sits in San Bernardino County, California - inside a USGS critical mineral priority focus area and within the dense southwestern cluster of deposits that define the country\u2019s remaining critical mineral endowment.',
  caption: 'Mines and mineral deposits with identified critical mineral resources in the United States.',
  source: 'Source: Hammarstrom and others, USGS Data Release, 2026. Whitemoon location annotated by Whitemoon Magnesium.',
};

export const videos = [
  { title: 'Whitemoon', subtitle: 'Site overview - Whitemoon Magnesite Deposit', poster: 'aerialPit', duration: '0:23', src: '/whitemoon.mp4', posterUrl: '/whitemoon-poster.jpg' },
  { title: 'El Capitan Shaft', subtitle: 'Aerial flyover - historic workings and surface magnesite', duration: '0:58', src: '/captains-short.mp4', posterUrl: '/captains-poster.jpg' },
  { title: 'Whitemoon', subtitle: 'Aerial flyover - the Whitemoon magnesite deposit', duration: '0:44', src: '/whitemoon-v4.mp4', posterUrl: '/whitemoon-v4-poster.jpg' },
];


export const investor = {
  intro:
    'America no longer produces primary magnesium. Whitemoon owns one of the few high-grade magnesite deposits in the United States - with a recognized right to mine it.',
  market: [
    { value: '~90%', label: 'of global primary magnesium production controlled by China' },
    { value: '2021', label: 'the last US primary producer halted output at the Great Salt Lake plant' },
    { value: '~3x', label: 'US spot magnesium trades near US$7,000/t - roughly triple the Chinese export price' },
  ],
  marketNote:
    'Magnesium is a designated US critical mineral and the European Union\u2019s second-most-critical raw material - essential to aerospace, automotive and defense. Sources: USGS Mineral Commodity Summaries; public record.',
  asset: [
    {
      title: 'Owned',
      text: 'The Whitemoon deposit sits on a 55-acre patented parcel - surface and minerals conveyed by a 1953 federal patent - together with the adjacent El Capitan claims. 100% Whitemoon-owned, with no lease royalty.',
    },
    {
      title: 'The right to mine, recognized',
      text: 'San Bernardino County has approved a Certificate of Land Use Compliance recognizing Whitemoon\u2019s vested right to mine. Under California law a vested mining right is a property right - requiring no discretionary use permit, only an approved reclamation plan with financial assurances.',
    },
  ],
  strategy: [
    { step: 'Confirm', text: 'Drill program and an independent, code-compliant mineral resource report, alongside reclamation plan approval.' },
    { step: 'Produce', text: 'Early magnesite production under the company\u2019s Fast-Track strategy - generating ore-sales revenue while the plant is developed.' },
    { step: 'Scale', text: 'A modular magnesium oxide (MgO) plant serving refractory, construction, agricultural and metal-feedstock markets. 99.9% purity magnesium has already been produced from Whitemoon ore at laboratory scale.' },
  ],
  validation: [
    { count: '1', label: 'MgO board manufacturer', note: 'Letter of intent' },
    { count: '3', label: 'Magnesium metal producers', note: 'Letters of intent' },
    { count: '1', label: 'Magnesium commodity trading house', note: 'Letter of intent' },
  ],
  validationNote:
    'Whitemoon is in active technical and pricing discussions with international magnesium processors regarding ore offtake, and has been accepted into the Defense Industrial Base Consortium (DIBC).',
  disclaimer:
    'Nothing on this website constitutes an offer to sell, or a solicitation of an offer to buy, any security. Any offering will be made only to qualified investors pursuant to definitive documentation and applicable exemptions under US securities laws. Historical estimates referenced are not current Mineral Resources. The Exploration Target is conceptual in nature; there has been insufficient exploration to define a Mineral Resource and it is uncertain whether further exploration will result in the definition of a Mineral Resource. This website contains forward-looking statements that involve significant risks and uncertainties, including exploration, permitting, financing and market risks; actual results may differ materially.',
};
